import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DomainManagerService } from '../service/domain-manager.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit {
  currentApplicationVersion = environment.appVersion;
  today: number = Date.now();
  logoUrl: string = '';

  constructor( private readonly domainService: DomainManagerService) { }

  ngOnInit(): void {
        this.logoUrl = this.domainService.getLogoUrl();
  }

}
